module.exports = __webpack_public_path__ + "img/btn2.ceab24d7.png";